export enum MediaType {
  MOBILE_S = 0,
  MOBILE = 1,
  TABLET = 2,
  DESKTOP = 3,
  DESKTOP_L = 4,
}

export enum MediaQuery {
  DESKTOP_L = '(min-width: 1476px)',
  DESKTOP = '(min-width: 1169px) and (max-width: 1475px)',
  TABLET = '(min-width: 1017px) and (max-width: 1168px)',
  MOBILE = '(min-width: 659px) and (max-width: 1016px)',
  MOBILE_S = '(max-width: 658px)',
}

export enum ScreenType {
  BASE = 0,
  SM = 1,
  MD = 2,
  LG = 3,
  XL = 4,
  XXL = 5,
}

export enum GameItemMode {
  grid = 0,
  random = 1,
  jackpot = 2,
}

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export enum DepositStatusMode {
  Successful = 'success',
  Pending = 'pending',
  Failure = 'failure',
}

export enum BooleanString {
  TRUE = 'true',
  FALSE = 'false',
}
